import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum TabType {
  LineBellow = 'line-bellow',
  Pill = 'pill'
}

export enum TabSize {
  SM = 'sm',
  RG = 'rg',
  MD = 'md'
}

export type TabOptions = [TabOption | null, TabOption | null];

export type TabDefaultOption = 0 | 1;

export interface TabOption {
  Title: string;
  Icon: Icon | null;
  Subtitle?: string;
  HasNotifications?: boolean;
}

export interface TabSelectedEvent {
  tab: TabOption;
  option: TabDefaultOption;
}
